import { useAuth } from '@/lib/auth';
import { Link } from '@tanstack/react-router';
import { FaCalendar, FaSignOutAlt, FaUsers } from 'react-icons/fa';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

export default function Header() {
  const { user, logout, isAdmin } = useAuth();

  return (
    <header className="w-full h-16 border-b border-primary shadow-md bg-black/25 flex items-center gap-4 px-4">
      <section className="flex items-center gap-2">
        <img src="/logo_color.png" alt="SubtopFR" className="h-10" />
        <h1 className="text-2xl font-bold">SubtopFR</h1>
      </section>
      <nav className="flex flex-grow items-center gap-2">
        <Link to="/dashboard/matchs">
          <Button
            variant="outline"
            className="flex items-center gap-2 cursor-pointer"
          >
            <FaCalendar />
            Matchs
          </Button>
        </Link>
        {isAdmin() && (
          <Link to="/dashboard/users">
            <Button
              variant="outline"
              className="flex items-center gap-2 cursor-pointer"
            >
              <FaUsers />
              Utilisateurs
            </Button>
          </Link>
        )}
      </nav>
      <section className="flex items-center gap-2 justify-self-end">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="outline"
              className="flex items-center gap-2 p-6 cursor-pointer"
            >
              <img
                src={user?.avatar}
                alt="Avatar"
                className="w-8 h-8 rounded-full object-cover"
              />
              <p>{user?.username}</p>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem className="cursor-pointer">
              <button
                onClick={logout}
                className="cursor-pointer flex gap-2 items-center font-medium"
              >
                <FaSignOutAlt className="text-text" />
                Se déconnecter
              </button>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </section>
    </header>
  );
}
